import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { TClipDeclaration } from '../types';

type TDeleteClipDeclarationsParams = {
  id: string;
  silently?: boolean;
};
export async function deleteClipDeclaration({
  id,
}: TDeleteClipDeclarationsParams): Promise<TClipDeclaration> {
  return mediaManagerClient.delete(`/api/v1/clip_declarations/${id}`);
}

type MutationFn = typeof deleteClipDeclaration;

type TUsePostFeaturedPeopleParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteClipDeclaration({ config = {} }: TUsePostFeaturedPeopleParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: ({ silently = false, ...params }: TDeleteClipDeclarationsParams) =>
      deleteClipDeclaration({ ...params, silently }),
    onError(error) {
      addErrorNotification(t('No se ha podido eliminar la declaración del corte'));
      console.error(error);
    },
    onSuccess(_data, variables: TDeleteClipDeclarationsParams) {
      if (!variables.silently) {
        addSuccessNotification(t('La declaración del corte se ha eliminado correctamente'));
        queryClient.invalidateQueries({ queryKey: ['clips'] });
      }
    },
  });
}
